import { Pipe, PipeTransform } from '@angular/core';
import { AppService } from '@app/core/services/app.service';

@Pipe({
  name: 'filterTable'
})
export class FilterTablePipe implements PipeTransform {

  constructor(private app: AppService) { }

  transform(items: any[], search: string, fields: any[]): any {
    if (!items) {
      return [];
    }

    if (!search) {
      return items;
    }

    search = this.app.normalizeText(search);

    // Sem searchField, busca em todos os campos de texto do item
    return items.filter(item => {
      const campos = fields?.length ? fields : Object.keys(item);
      return campos.some(field => {
        const valor = item[field];
        if (typeof valor !== 'string' && typeof valor !== 'number') return false;
        return this.app.normalizeText(String(valor)).includes(search);
      });
    });
  }

}
